import { v4 as uuidv4 } from 'uuid'
import { OpalApiComponent } from '../../schema'

type Workflow = OpalApiComponent<'V2', 'workflow'>

type Attributes = {
  entityId: string
  stageId?: string
}

const defaultAttributes: OpalApiComponent<'V2', 'workflow'>['attributes'] = {
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  deleted_at: null,
  status: 'inactive',
  is_approved: false,
  progress: 'not_started',
}

export const resourceObject = ({
  entityId,
  stageId,
}: Attributes): Workflow => ({
  id: uuidv4(),
  type: 'workflow',
  attributes: {
    ...defaultAttributes,
  },
  relationships: {
    stages: {
      data: [{ id: stageId ?? uuidv4(), type: 'stage' }],
    },
    context: {
      data: { id: entityId, type: 'context' },
    },
    created_by_user: {
      data: { id: uuidv4(), type: 'user' },
    },
  },
})
